import React, { useEffect, useState } from "react";

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (event) => {
      setPosition({
        x: event.clientX,
        y: event.clientY,
      });
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: position.y,
        left: position.x,
        width: "10px",
        height: "10px",
        backgroundColor: "transparent", // Center is transparent
        borderRadius: "50%", // Makes it circular
        pointerEvents: "none", // Prevents blocking interactions
        transform: "translate(-50%, -50%)", // Centers the cursor
        zIndex: 9999, // Ensures it's on top of everything
        boxShadow: `
          0 0 0 2px rgba(0, 0, 0, 0.8),   /* Inner black outline */
          0 0 0 6px rgba(128, 128, 128, 0.5) /* Outer grey outline */
        `, // Creates concentric circles
      }}
    />
  );
};

export default CustomCursor;